import { Component, OnInit, AfterViewInit, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, NavigationEnd, NavigationStart, NavigationCancel } from '@angular/router';
import { AppConfigService } from './app-config.service';
import { Store } from '@ngxs/store';
import { HideLoader, ShowLoader } from './shared/personne.state';
import { GtmService } from './shared/services/gtm.service';
import { GTM_PUSH_CATEGORY, GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES } from './shared/modeles/variables';
import { TNRService } from './shared/services/tnr.service';
import { ContextService } from './shared/services/context-service/context.service';
import { DOCUMENT } from '@angular/common';
import { ToolPreautorisationService } from './tool-preautorisation/tool-preautorisation.service';
import { ComportementRetourEnum } from './core/modeles/comportement-retour.enum';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit, AfterViewInit {
  isLoaded = false;
  isApp = false;
  langue = 'fr';

  titreMobile: string;
  isNavBarDisplayed = true;
  isDsdContext = false;

  constructor(
    private readonly _translateService: TranslateService,
    private readonly _router: Router,
    private readonly _appConfigService: AppConfigService,
    private readonly _store: Store,
    private readonly _gtm: GtmService,
    @Inject(DOCUMENT) private _document: Document,
    private readonly _contextService: ContextService,
    private readonly _tnrService: TNRService,
    private readonly _toolPreautorisationService: ToolPreautorisationService,
    private readonly _titleService: Title
  ) {}

  async ngOnInit() {
    this._store.dispatch(new ShowLoader());
    this.isApp = this._appConfigService.isApp;
    this.initializeLangue();
    this.clearTNRCookie();
    this._translateService
      .get(`header.titres.${this._appConfigService.typeProjet || 'default'}`)
      .subscribe((translation: string) => {
        this.titreMobile = translation;
        this._titleService.setTitle(translation);
      });

    this.completeLoad();

    this.handleNavigationEvents();
    this.isDsdContext = this._contextService.isDsdContext;
    this._store.dispatch(new HideLoader());
  }

  ngAfterViewInit() {
    this._gtm.pushEvent({
      event: GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES,
      category: GTM_PUSH_CATEGORY,
      label: this._gtm.urlProvenance,
      action: 'entree',
      value: 0,
      nonInteraction: false
    });
  }

  private clearTNRCookie() {
    this._tnrService.removeTNRCookie();
  }

  private handleNavigationEvents() {
    this._router.events.subscribe(evt => {
      if (evt instanceof NavigationStart) {
        this._store.dispatch(new ShowLoader());
      } else if (evt instanceof NavigationCancel || evt instanceof NavigationEnd) {
        this._store.dispatch(new HideLoader());
      }

      this.isDsdContext = this._contextService.isDsdContext;
      this.isNavBarDisplayed = !(this._router.url === '/aiguilleur');
      window.scrollTo(0, 0);
    });
  }

  private completeLoad() {
    this._store.dispatch(new HideLoader());
    this.isLoaded = true;
  }

  private initializeLangue() {
    this.langue = this._appConfigService.langue;
    this._document.documentElement.lang = this.langue;
    this._translateService.setDefaultLang('fr');
    this._translateService.use(this.langue);
  }

  async headerLinkClick(returnUrl: string) {
    await this._toolPreautorisationService.annulerPreautorisationAvecConfirmation(returnUrl);
  }

  get comportementBoutonRetour(): ComportementRetourEnum {
    return this._contextService.getDataValue('comportementRetour') || ComportementRetourEnum.Retour;
  }

  get libelleBoutonRetour(): string {
    return this._contextService.getDataValue('libelleBoutonRetour') || 'header.retour';
  }

  get urlRetour() {
    return this._appConfigService.urlRetour;
  }
}
